import React from 'react';

const SubscribeFullIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <mask
      id='mask0'
      type='alpha'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='16'
      height='16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.00956 15.8667L7.96342 12.2037L12.9173 15.8666C13.0502 15.9333 13.1832 16 13.3162 16C13.4492 16 13.5822 15.9333 13.7817 15.8C13.9812 15.6666 14.1142 15.3333 13.9812 15.0666L11.894 9.34297L15.71 6.53334C15.976 6.40001 16.0425 6.06668 15.976 5.80001C15.843 5.53334 15.577 5.33334 15.3111 5.33334H11.9863H10.3547L8.5951 0.466667C8.52861 0.2 8.26263 0 7.99665 0C7.73067 0 7.46469 0.2 7.3317 0.466667L5.57209 5.33332H0.682244C0.416265 5.33332 0.150287 5.53332 0.0172972 5.79999C-0.0491974 6.06666 0.0837919 6.33333 0.283276 6.53333L4.13997 9.39999L2.07863 15.1333C1.94564 15.4 2.01214 15.6667 2.27812 15.8667C2.4111 15.9333 2.54409 16 2.67708 16C2.81007 16 2.94306 15.9333 3.00956 15.8667Z'
        fill='#FFE600'
      />
    </mask>
    <g mask='url(#mask0)'>
      <rect width='16' height='17' fill='#FFE500' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.925 6.66667C9.65902 6.66667 9.39304 6.46667 9.32654 6.2L7.99665 2.6L6.66676 6.2C6.64555 6.25316 6.61757 6.30294 6.58418 6.34851C6.47613 6.5473 6.26874 6.66666 6.00182 6.66666H2.67708L5.33687 8.59999C5.60285 8.79999 5.66934 9.06666 5.53635 9.33333L4.00698 13.4667L7.53119 10.8667C7.64943 10.7778 7.80708 10.7415 7.96326 10.7522C8.11954 10.7415 8.27731 10.7777 8.39562 10.8666L11.9198 13.4666L10.5324 9.54642L10.5235 9.53334C10.3446 9.2942 10.3796 8.89421 10.5805 8.66995C10.6444 8.59287 10.7241 8.52854 10.8152 8.48458L13.3162 6.66668H11.9873C11.987 6.66668 11.9866 6.66668 11.9863 6.66668L9.9915 6.66668C9.98993 6.66668 9.98836 6.66667 9.98679 6.66667H9.925ZM11.9863 5.33334H15.3111C15.577 5.33334 15.843 5.53334 15.976 5.80001C16.0425 6.06668 15.976 6.40001 15.71 6.53334L11.894 9.34297L13.9812 15.0666C14.1142 15.3333 13.9812 15.6666 13.7817 15.8C13.5822 15.9333 13.4492 16 13.3162 16C13.1832 16 13.0502 15.9333 12.9173 15.8666L7.96342 12.2037L3.00956 15.8667C2.94306 15.9333 2.81007 16 2.67708 16C2.54409 16 2.4111 15.9333 2.27812 15.8667C2.01214 15.6667 1.94564 15.4 2.07863 15.1333L4.13997 9.39999L0.283276 6.53333C0.0837919 6.33333 -0.0491974 6.06666 0.0172972 5.79999C0.150287 5.53332 0.416265 5.33332 0.682244 5.33332H5.57209L7.33171 0.466667C7.46469 0.2 7.73067 0 7.99665 0C8.26263 0 8.52861 0.2 8.5951 0.466667L10.3547 5.33334H11.9863Z'
        fill='#FFE600'
      />
    </g>
  </svg>
);

export default SubscribeFullIcon;
